import { render, staticRenderFns } from "./ReceiveDetails_Action.vue?vue&type=template&id=4490a1f9&"
import script from "./ReceiveDetails_Action.vue?vue&type=script&lang=js&"
export * from "./ReceiveDetails_Action.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports